<template>
  <li class="list-group-item">
    <SkeletonBox width="100%" v-if="loading" />
    <template v-if="!loading">
      <span class="float-right">
        <slot />
      </span>
      {{title}}
    </template>
  </li>
</template>

<style>
ul > li.list-group-item:first-child {
  border-top: none !important;
}
</style>

<script>
export default {
  name: "OverviewBoxListItem",
  props: {
    title: String
  },
  computed: {
    loading() {     
      var loadingComponent = this.findLoadingParent(this.$parent)
      if(loadingComponent)
        return loadingComponent.$props.loading

      return false
    }
  },
  methods: {
    // Recursively find the parent 'ContentBox' or 'TabbedBox' components for the data item
    // Checks the parent's loading prop
    findLoadingParent(comp) {
      if(comp == null)
        return null
      if(comp.$options.name == 'OverviewBox')
        return comp

      return this.findLoadingParent(comp.$parent)
    }
  }
};
</script>